module.exports = __webpack_public_path__ + "img/icon-email2.e9fd3081.svg";